import $http from '@Config/axios';
import $store from '@Store';

const prefix = 'instituicao';

export default {
  show(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  update(params) {
    return new Promise((resolve, reject) => {
      $http.put(`${prefix}/${params.id}`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: 'Dados atualizados com sucesso!' });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  aniversariantes(mes) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/aniversariantes/${mes}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  storeHome(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/home`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  getConfiguracoes() {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/configuracoes`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  storeConfiguracoes(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/configuracoes`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: 'Configurações salvas com sucesso' });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  storeAvatar(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/storeAvatar`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: 'Avatar salvo com sucesso' });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  adicionarIdentificador(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/identificacao`, params)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  getPacientes() {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/pacientes`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  googleMapsProxy() {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/google-maps-proxy`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
